import React from 'react';
import IconMenu from "@material-ui/icons/Menu";

const drawerToggle = (props) => (
    <div className="drawer__toggle" onClick={props.clicked}>
         <IconMenu/>
    </div>
);

export default drawerToggle;